import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cart } from './cart.model';
import {
  ActiveCartService,
  ErrorModel,
  EventService,
  OccEndpointsService,
  MultiCartService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { iShippingAddress, iUpdateCartAddressRequest } from './cart.model';




export interface AddressValidation {
  decision?: string;
  // TODO: Simplify with converter
  errors?: { errors: ErrorModel[] };
}

@Injectable({ providedIn: 'root' })
export class CartService {
  userId: string | undefined;
  outOfStock: boolean = false;
  PartialStock: boolean = false;
  onContinueBtnClick = new BehaviorSubject<boolean>(false);
  cartEntryUpdates = new BehaviorSubject<any>([]);
  onButtonEnableDisable = new BehaviorSubject<boolean>(false);
  $orderSimulateResponse = new BehaviorSubject<any>({});
  $orderPlaceResponse = new BehaviorSubject<any>({});
  constructor(
    private httpClient: HttpClient,
    private occService: OccEndpointsService,
    private userAccount: UserAccountFacade,
    private activeCart: ActiveCartService,
    protected eventService: EventService,
    protected multiCartService: MultiCartService
  ) { }

  
  getCart(): Observable<Cart> {
    // Implement the logic to fetch the cart data
    // Replace this with your actual implementation
    return of({ entries: [] }); // Example placeholder
  }


  getTheListOfShippingAddress(): Observable<iShippingAddress | undefined> {
    return this.userAccount
      .get()
      .pipe(
        mergeMap(({ uid, orgUnit }: any) =>
          this.httpClient.get<any>(
            this.occService.buildUrl(
              `/users/${uid}/orgUnits/${orgUnit?.uid}/shipToAddresses?fields=FULL`
            )
          )
        )
      );
  }

  setAsDefaultAddress(shipToID: any): Observable<any> {
    return this.userAccount
      .get()
      .pipe(
        mergeMap(({ uid }: any) =>
          this.httpClient.post<any>(
            this.occService.buildUrl(
              `/orgUsers/${uid}/updateDefaultUserAddress/${shipToID}`
            ),
            ''
          )
        )
      );
  }

  updateCartOrder(
    requestBody: iUpdateCartAddressRequest | undefined
  ): Observable<any> {
    return combineLatest([
      this.userAccount.get(),
      this.activeCart.getActiveCartId(),
    ]).pipe(
      mergeMap(([{ uid }, cartId]: any) =>
        this.httpClient.post<any>(
          this.occService.buildUrl(
            `orgUsers/${uid}/carts/${cartId}/update?fields=FULL`
          ),
          requestBody
        )
      )
    );
  }

  updateOrderSimulate() {
    return combineLatest([
      this.userAccount.get(),
      this.activeCart.getActiveCartId(),
    ]).pipe(
      mergeMap(([{ uid }, cartId]: any) =>
        this.httpClient.post<any>(
          this.occService.buildUrl(
            `orgUsers/${uid}/carts/${cartId}/simulate?fields=FULL`
          ),
          {}
        )
      )
    );
  }

  onPlaceOrder() {
    return combineLatest([
      this.userAccount.get(),
      this.activeCart.getActiveCartId(),
    ]).pipe(
      mergeMap(([{ uid }, cartId]: any) =>
        this.httpClient.post<any>(
          this.occService.buildUrl(
            `orgUsers/${uid}/orders?cartId=${cartId}&fields=FULL&termsChecked=true`
          ),
          {}
        )
      )
    );
  }

  loadCarts() {
    let isAsmUser = localStorage.getItem('asm_enabled');
    return this.userAccount.get().pipe(
      mergeMap((user: any) => {
        let userId = isAsmUser ? user.customerId : 'current';
        return user !== undefined
          ? this.httpClient.get<any>(
            this.occService.buildUrl(
              `/users/${userId}/carts?fields=carts(DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue, value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description)`
            ),
            {}
          )
          : of({});
      })
    );
  }

  deleteCart(cartId: string,uid: string){
    this.multiCartService.deleteCart(cartId,uid)
  }

  createNewCart(uid: string){
    return this.multiCartService.createCart({
      userId: uid
    })
  }
  activateCart(cartId: string,userId: string){
    this.multiCartService.loadCart({ cartId: cartId, userId: userId })
  }
}
